import ModalSinistro from "./modalSinistro";

export default ModalSinistro;
